import {WPHOTO_CUSTOM_DESIGN_TYPE} from './decorations/wphoto/constants'
import {IMAGEX_CUSTOM_DESIGN_TYPE} from './decorations/imagex/constants'

export interface PropertyTypeMetadata {
    type: string
    itemsMetadata?: PropertyMetadata
    argsMetadata?: Record<string, PropertyMetadata>
}

export interface PropertyMetadata {
    types: PropertyTypeMetadata[]
}

export type ArrayPropertyTypeMetadata = PropertyTypeMetadata & Pick<Required<PropertyTypeMetadata>, 'itemsMetadata'>

export type FunctionPropertyTypeMetadata = PropertyTypeMetadata & Pick<Required<PropertyTypeMetadata>, 'argsMetadata'>

export const METADATA: Record<string, Record<string, Record<string, PropertyMetadata>>> = {
    layout: {
        SingleLayoutData: {
            'componentLayout.containerType': {types: [{type: 'String'}]},
            'componentLayout.width': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'componentLayout.height': {
                types: [{type: 'AspectRatioSize'}, {type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'componentLayout.minWidth': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'componentLayout.minHeight': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'componentLayout.maxWidth': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'componentLayout.maxHeight': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'componentLayout.margins.top': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'componentLayout.margins.bottom': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'componentLayout.margins.left': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'componentLayout.margins.right': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'componentLayout.direction': {types: [{type: 'String'}]},
            'componentLayout.rotationInDegrees': {types: [{type: 'Number'}]},
            'componentLayout.fixed': {types: [{type: 'Boolean'}]},
            'componentLayout.hidden': {types: [{type: 'Boolean'}]},
            'componentLayout.type': {types: [{type: 'String'}]},
            'itemLayout.type': {types: [{type: 'String'}]},
            'itemLayout.scrollSnapAlign': {types: [{type: 'String'}]},
            'itemLayout.pinnedToContainer': {types: [{type: 'Boolean'}]},
            'itemLayout.margins.top': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'itemLayout.margins.bottom': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'itemLayout.margins.left': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'itemLayout.margins.right': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'itemLayout.position': {types: [{type: 'String'}]},
            'itemLayout.top': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'itemLayout.bottom': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'itemLayout.left': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'itemLayout.right': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'itemLayout.gridArea.rowStart': {types: [{type: 'Number'}]},
            'itemLayout.gridArea.columnStart': {types: [{type: 'Number'}]},
            'itemLayout.gridArea.rowEnd': {types: [{type: 'Number'}]},
            'itemLayout.gridArea.columnEnd': {types: [{type: 'Number'}]},
            'itemLayout.alignSelf': {types: [{type: 'String'}]},
            'itemLayout.justifySelf': {types: [{type: 'String'}]},
            'itemLayout.order': {types: [{type: 'Number'}]},
            'itemLayout.basis': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'itemLayout.grow': {types: [{type: 'Number'}]},
            'itemLayout.shrink': {types: [{type: 'Number'}]},
            'containerLayout.rows': {
                types: [
                    {
                        type: 'Array',
                        itemsMetadata: {
                            types: [
                                {type: 'MinMaxSize'},
                                {type: 'Repeat'},
                                {type: 'UnitSize'},
                                {type: 'Calculation'},
                                {type: 'KeywordSize'}
                            ]
                        }
                    }
                ]
            },
            'containerLayout.columns': {
                types: [
                    {
                        type: 'Array',
                        itemsMetadata: {
                            types: [
                                {type: 'MinMaxSize'},
                                {type: 'Repeat'},
                                {type: 'UnitSize'},
                                {type: 'Calculation'},
                                {type: 'KeywordSize'}
                            ]
                        }
                    }
                ]
            },
            'containerLayout.rowGap': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.columnGap': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.autoRows': {
                types: [
                    {
                        type: 'Array',
                        itemsMetadata: {
                            types: [
                                {type: 'MinMaxSize'},
                                {type: 'Repeat'},
                                {type: 'UnitSize'},
                                {type: 'Calculation'},
                                {type: 'KeywordSize'}
                            ]
                        }
                    }
                ]
            },
            'containerLayout.autoColumns': {
                types: [
                    {
                        type: 'Array',
                        itemsMetadata: {
                            types: [
                                {type: 'MinMaxSize'},
                                {type: 'Repeat'},
                                {type: 'UnitSize'},
                                {type: 'Calculation'},
                                {type: 'KeywordSize'}
                            ]
                        }
                    }
                ]
            },
            'containerLayout.autoFlow': {types: [{type: 'String'}]},
            'containerLayout.overflowY': {types: [{type: 'String'}]},
            'containerLayout.overflowX': {types: [{type: 'String'}]},
            'containerLayout.hideScrollbar': {types: [{type: 'Boolean'}]},
            'containerLayout.padding.top': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.padding.bottom': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.padding.left': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.padding.right': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.scrollSnap.scrollSnapType': {
                types: [{type: 'String'}]
            },
            'containerLayout.scrollSnap.scrollSnapDirection': {
                types: [{type: 'String'}]
            },
            'containerLayout.scrollBehavior': {types: [{type: 'String'}]},
            'containerLayout.type': {types: [{type: 'String'}]},
            'containerLayout.contain': {types: [{type: 'String'}]},
            'containerLayout.scrollSnapAlign': {
                types: [{type: 'String'}]
            },
            'containerLayout.pinnedToContainer': {
                types: [{type: 'Boolean'}]
            },
            'containerLayout.margins.top': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.margins.bottom': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.margins.left': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.margins.right': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.position': {types: [{type: 'String'}]},
            'containerLayout.top': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.bottom': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.left': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.right': {
                types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]
            },
            'containerLayout.direction': {types: [{type: 'String'}]},
            'containerLayout.wrap': {types: [{type: 'String'}]},
            'containerLayout.alignItems': {types: [{type: 'String'}]},
            'containerLayout.justifyContent': {types: [{type: 'String'}]},
            'containerLayout.scrollBehaviour': {
                types: [{type: 'String'}]
            },
            'containerLayout.contentMaxWidth.maxWidth': {types: [{type: 'UnitSize'}]},
            'containerLayout.contentMaxWidth.align': {types: [{type: 'String'}]},
            'containerLayout.layoutIntent': {types: [{type: 'String'}]},
            type: {types: [{type: 'String'}]}
        }
    },
    design: {
        [WPHOTO_CUSTOM_DESIGN_TYPE]: {
            crop: {types: [{type: 'Crop'}]},
            cropMask: {types: [{type: 'CropMask'}]},
            focalPoint: {types: [{type: 'FocalPoint'}]},
            type: {types: [{type: 'String'}]}
        },
        [IMAGEX_CUSTOM_DESIGN_TYPE]: {
            crop: {types: [{type: 'Crop'}]},
            cropMask: {types: [{type: 'CropMask'}]},
            focalPoint: {types: [{type: 'FocalPoint'}]},
            scrollEffect: {types: [{type: 'String'}]},
            type: {types: [{type: 'String'}]}
        },
        MediaContainerDesignData: {
            charas: {types: [{type: 'String'}]},
            'background.mediaRef': {types: [{type: 'String'}]},
            'background.mediaTransforms.scale': {
                types: [{type: 'Number'}]
            },
            'background.mediaTransforms.opacity': {
                types: [{type: 'Number'}]
            },
            'background.overlayTransforms.scale': {
                types: [{type: 'Number'}]
            },
            'background.overlayTransforms.opacity': {
                types: [{type: 'Number'}]
            },
            'background.color': {types: [{type: 'String'}]},
            'background.colorOpacity': {types: [{type: 'Number'}]},
            'background.alignType': {types: [{type: 'String'}]},
            'background.fittingType': {types: [{type: 'String'}]},
            'background.scrollType': {types: [{type: 'String'}]},
            'background.showOverlayForMediaType': {
                types: [{type: 'String'}]
            },
            'background.imageOverlay': {types: [{type: 'String'}]},
            'background.colorOverlay': {types: [{type: 'String'}]},
            'background.colorOverlayOpacity': {
                types: [{type: 'Number'}]
            },
            'background.overlayBlending.color': {
                types: [{type: 'String'}]
            },
            'background.overlayBlending.opacity': {
                types: [{type: 'Number'}]
            },
            'background.overlayBlending.contrast': {
                types: [{type: 'Number'}]
            },
            'background.overlayBlending.saturate': {
                types: [{type: 'Number'}]
            },
            'background.overlayBlending.blendMode': {
                types: [{type: 'String'}]
            },
            'background.filterEffect.effectType': {
                types: [{type: 'String'}]
            },
            'background.filterEffect.brightness': {
                types: [{type: 'Number'}]
            },
            'background.filterEffect.contrast': {
                types: [{type: 'Number'}]
            },
            'background.filterEffect.saturation': {
                types: [{type: 'Number'}]
            },
            'background.filterEffect.hue': {types: [{type: 'Number'}]},
            'background.filterEffect.duotoneDark': {
                types: [{type: 'String'}]
            },
            'background.filterEffect.duotoneLight': {
                types: [{type: 'String'}]
            },
            'background.filterEffect.invert': {
                types: [{type: 'Boolean'}]
            },
            'background.filterEffect.isCustom': {
                types: [{type: 'Boolean'}]
            },
            'background.colorLayers': {
                types: [
                    /*{type: 'GradientLayer'}, {type: 'SolidColorLayer'}*/
                ]
            },
            dataChangeBehaviors: {
                types: [{type: 'Array', itemsMetadata: {types: [{type: 'DataChangeBehavior'}]}}]
            },
            'cssStyle.cssBorder.width.top': {types: [{type: 'CssUnit'}]},
            'cssStyle.cssBorder.width.right': {types: [{type: 'CssUnit'}]},
            'cssStyle.cssBorder.width.bottom': {types: [{type: 'CssUnit'}]},
            'cssStyle.cssBorder.width.left': {types: [{type: 'CssUnit'}]},
            'cssStyle.cssBorder.style.top': {types: [{type: 'String'}]},
            'cssStyle.cssBorder.style.right': {types: [{type: 'String'}]},
            'cssStyle.cssBorder.style.bottom': {types: [{type: 'String'}]},
            'cssStyle.cssBorder.style.left': {types: [{type: 'String'}]},
            'cssStyle.cssBorder.color.top': {types: [{type: 'CssColor'}]},
            'cssStyle.cssBorder.color.right': {types: [{type: 'CssColor'}]},
            'cssStyle.cssBorder.color.bottom': {types: [{type: 'CssColor'}]},
            'cssStyle.cssBorder.color.left': {types: [{type: 'CssColor'}]},
            'cssStyle.cssBoxShadow': {
                types: [
                    /*{type: 'Array', itemsMetadata: {types: [{type: 'CssBoxShadow'}]}}*/
                ]
            },
            'cssStyle.cssBorderRadius.topLeft': {types: [{type: 'CssUnit'}]},
            'cssStyle.cssBorderRadius.topRight': {types: [{type: 'CssUnit'}]},
            'cssStyle.cssBorderRadius.bottomLeft': {
                types: [{type: 'CssUnit'}]
            },
            'cssStyle.cssBorderRadius.bottomRight': {
                types: [{type: 'CssUnit'}]
            },
            type: {types: [{type: 'String'}]}
        },
        MediaPlayerDesignData: {
            charas: {types: [{type: 'String'}]},
            'background.mediaRef': {types: [{type: 'String'}]},
            'background.mediaTransforms.scale': {
                types: [{type: 'Number'}]
            },
            'background.mediaTransforms.opacity': {
                types: [{type: 'Number'}]
            },
            'background.overlayTransforms.scale': {
                types: [{type: 'Number'}]
            },
            'background.overlayTransforms.opacity': {
                types: [{type: 'Number'}]
            },
            'background.color': {types: [{type: 'String'}]},
            'background.colorOpacity': {types: [{type: 'Number'}]},
            'background.alignType': {types: [{type: 'String'}]},
            'background.fittingType': {types: [{type: 'String'}]},
            'background.scrollType': {types: [{type: 'String'}]},
            'background.showOverlayForMediaType': {
                types: [{type: 'String'}]
            },
            'background.imageOverlay': {types: [{type: 'String'}]},
            'background.colorOverlay': {types: [{type: 'String'}]},
            'background.colorOverlayOpacity': {
                types: [{type: 'Number'}]
            },
            'background.overlayBlending.color': {
                types: [{type: 'String'}]
            },
            'background.overlayBlending.opacity': {
                types: [{type: 'Number'}]
            },
            'background.overlayBlending.contrast': {
                types: [{type: 'Number'}]
            },
            'background.overlayBlending.saturate': {
                types: [{type: 'Number'}]
            },
            'background.overlayBlending.blendMode': {
                types: [{type: 'String'}]
            },
            'background.filterEffect.effectType': {
                types: [{type: 'String'}]
            },
            'background.filterEffect.brightness': {
                types: [{type: 'Number'}]
            },
            'background.filterEffect.contrast': {
                types: [{type: 'Number'}]
            },
            'background.filterEffect.saturation': {
                types: [{type: 'Number'}]
            },
            'background.filterEffect.hue': {types: [{type: 'Number'}]},
            'background.filterEffect.duotoneDark': {
                types: [{type: 'String'}]
            },
            'background.filterEffect.duotoneLight': {
                types: [{type: 'String'}]
            },
            'background.filterEffect.invert': {
                types: [{type: 'Boolean'}]
            },
            'background.filterEffect.isCustom': {
                types: [{type: 'Boolean'}]
            },
            'background.colorLayers': {
                types: [
                    /*{type: 'GradientLayer'}, {type: 'SolidColorLayer'}*/
                ]
            },
            'cssStyle.cssBorder.width.top': {types: [{type: 'CssUnit'}]},
            'cssStyle.cssBorder.width.right': {types: [{type: 'CssUnit'}]},
            'cssStyle.cssBorder.width.bottom': {types: [{type: 'CssUnit'}]},
            'cssStyle.cssBorder.width.left': {types: [{type: 'CssUnit'}]},
            'cssStyle.cssBorder.style.top': {types: [{type: 'String'}]},
            'cssStyle.cssBorder.style.right': {types: [{type: 'String'}]},
            'cssStyle.cssBorder.style.bottom': {types: [{type: 'String'}]},
            'cssStyle.cssBorder.style.left': {types: [{type: 'String'}]},
            'cssStyle.cssBorder.color.top': {types: [{type: 'CssColor'}]},
            'cssStyle.cssBorder.color.right': {types: [{type: 'CssColor'}]},
            'cssStyle.cssBorder.color.bottom': {types: [{type: 'CssColor'}]},
            'cssStyle.cssBorder.color.left': {types: [{type: 'CssColor'}]},
            'cssStyle.cssBoxShadow': {
                types: [
                    /*{type: 'Array', itemsMetadata: {types: [{type: 'CssBoxShadow'}]}}*/
                ]
            },
            'cssStyle.cssBorderRadius.topLeft': {types: [{type: 'CssUnit'}]},
            'cssStyle.cssBorderRadius.topRight': {types: [{type: 'CssUnit'}]},
            'cssStyle.cssBorderRadius.bottomLeft': {
                types: [{type: 'CssUnit'}]
            },
            'cssStyle.cssBorderRadius.bottomRight': {
                types: [{type: 'CssUnit'}]
            },
            type: {types: [{type: 'String'}]}
        },
        VectorImageDesignData: {
            'shapeStyle.opacity': {types: [{type: 'Number'}]},
            'shapeStyle.stroke': {types: [{type: 'Stroke'}]},
            'overrideColors.color1': {types: [{type: 'String'}]},
            'overrideColors.color2': {types: [{type: 'String'}]},
            'overrideColors.color3': {types: [{type: 'String'}]},
            'overrideColors.color4': {types: [{type: 'String'}]},
            'overrideColors.color5': {types: [{type: 'String'}]},
            'overrideColors.color6': {types: [{type: 'String'}]},
            'overrideColors.color7': {types: [{type: 'String'}]},
            'overrideColors.color8': {types: [{type: 'String'}]},
            shadow: {types: [{type: 'DropShadow'}]},
            type: {types: [{type: 'String'}]}
        }
    },
    style: {
        TopLevelStyle: {
            skin: {types: [{type: 'String'}]},
            styleType: {types: [{type: 'String'}]},
            pageId: {types: [{type: 'String'}]},
            compId: {types: [{type: 'String'}]},
            componentClassName: {types: [{type: 'String'}]},
            type: {types: [{type: 'String'}]}
        },
        ComponentStyle: {
            skin: {types: [{type: 'String'}]},
            styleType: {types: [{type: 'String'}]},
            pageId: {types: [{type: 'String'}]},
            compId: {types: [{type: 'String'}]},
            componentClassName: {types: [{type: 'String'}]},
            'spx.refWidth': {types: [{type: 'Number'}]},
            'spx.resolverType': {types: [{type: 'String'}]},
            'themeOverrides.spx.refWidth': {types: [{type: 'Number'}]},
            'themeOverrides.spx.resolverType': {types: [{type: 'String'}]},
            'style.properties.bg': {types: [{type: 'StylePropertyColor'}]},
            'style.properties.rd': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.txt': {types: [{type: 'StylePropertyColor'}, {type: 'StylePropertyFont'}]},
            'style.properties.brd': {types: [{type: 'StylePropertyColor'}]},
            'style.properties.brdh': {types: [{type: 'StylePropertyColor'}]},
            'style.properties.shd': {types: [{type: 'StylePropertyBoxShadow'}]},
            'style.properties.brw': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.tdr': {types: [{type: 'StylePropertyUrl'}]},
            'style.properties.fnt': {types: [{type: 'StylePropertyFont'}]},
            'style.properties.bgh': {types: [{type: 'StylePropertyColor'}]},
            'style.properties.txth': {types: [{type: 'StylePropertyColor'}]},
            'style.properties.trans': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.textDecoration': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.textAlign': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.fontFamily': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.fontSize': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.maxFontSize': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.minFontSize': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.color': {types: [{type: 'StylePropertyColor'}]},
            'style.properties.fontWeight': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.fontStyle': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.backgroundColor': {types: [{type: 'StylePropertyColor'}]},
            'style.properties.direction': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.lineHeight': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.letterSpacing': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.align': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.margin': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.horizontalPadding': {types: [{type: 'StylePropertyValue'}]},
            'style.properties.verticalPadding': {types: [{type: 'StylePropertyValue'}]},
            type: {types: [{type: 'String'}]}
        }
    }
}

export const ADDITIONAL_METADATA: Record<string, Partial<FunctionPropertyTypeMetadata>> = {
    MinMaxSize: {
        argsMetadata: {
            min: {types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]},
            max: {types: [{type: 'UnitSize'}, {type: 'Calculation'}, {type: 'KeywordSize'}]}
        }
    },
    Repeat: {
        argsMetadata: {
            length: {types: [{type: 'Number'}, {type: 'String'}]},
            value: {
                types: [
                    {
                        type: 'Array',
                        itemsMetadata: {
                            types: [
                                {type: 'MinMaxSize'},
                                {type: 'Repeat'},
                                {type: 'UnitSize'},
                                {type: 'Calculation'},
                                {type: 'KeywordSize'}
                            ]
                        }
                    }
                ]
            }
        }
    },
    CssColor: {
        argsMetadata: {
            red: {types: [{type: 'Number'}]},
            green: {types: [{type: 'Number'}]},
            blue: {types: [{type: 'Number'}]},
            alpha: {types: [{type: 'Number'}]}
        }
    }
}
